
<div class="container">
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-5">
        <div class="col-md-3"></div>
        <div class="col-md-6 login-form-1">
          <h3 class="misc-titles text-center">Login</h3>
          <div class="container" style="border:1px solid #bebaba">
            <p class="misc-titles text-center">
            <br/>
            </p>
            <div class="form-group">
              <label for="lucaClaimNumber" style="font-weight:bold">Claim Number: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="lucaClaimNumber" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.lucaClaimNumber.errors }" />
              <div *ngIf="submitted && f.lucaClaimNumber.errors" class="invalid-feedback">
                <div *ngIf="f.lucaClaimNumber.errors.required">This field is required</div>
                <div *ngIf="f.lucaClaimNumber.errors.minlength">This field must be at least 8 characters</div>
                <div *ngIf="f.lucaClaimNumber.errors.maxlength">
                  This field must not be greater than 15 characters
                </div>
                <div *ngIf="f.lucaClaimNumber.errors.pattern">This field accepts only numerical digits 0-9</div>
              </div>
            </div>
            <div class="form-group">
              <label for="phone1" style="font-weight:bold">Phone Number: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="phone1" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.phone1.errors }" />
              <div *ngIf="submitted && f.phone1.errors" class="invalid-feedback">
                <div *ngIf="f.phone1.errors.required">This field is required</div>
                <div *ngIf="f.phone1.errors.minlength">This field must be exactly 10 digits</div>
                <div *ngIf="f.phone1.errors.maxlength">
                  This field must be exactly 10 digits
                </div>
                <div *ngIf="f.phone1.errors.pattern">This field accepts only numerical digits 0-9</div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="form-group">
                  <button class="btn btn-primary" id="login" [disabled]="clicked">Login</button>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
          <br />
        </div>

        <div class="col-md-3"></div>
      </div>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <div class="row mt-3" *ngIf="showDivHasFiled == true">
      <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
        This UniqueId and Pin has already been used. Please contact the Settlement Administrator at <a href="mailto:info@CanogaParkClassAction.com">info@CanogaParkClassAction.com</a> for questions.
      </div>
    </div>
  </div>
</div>
